import { render, staticRenderFns } from "./OverlayDragDrop.vue?vue&type=template&id=747b9bd9"
import script from "./OverlayDragDrop.vue?vue&type=script&lang=js"
export * from "./OverlayDragDrop.vue?vue&type=script&lang=js"
import style0 from "./OverlayDragDrop.vue?vue&type=style&index=0&id=747b9bd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports